module.exports = __webpack_public_path__ + "img/logo-fri_reg.e7576608.svg";